export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const CONTENT = process.env.REACT_APP_CONTENT || "";
export const CONFIG = process.env.REACT_APP_CONFIG;
export const MODEL_BASE = process.env.REACT_APP_MODEL_BASE;
export const TEXTURE_BASE = process.env.REACT_APP_TEXTURE_BASE;

export const CONTENT_URL = SITE_URL + CONTENT;
export const CONFIG_URL = CONTENT_URL + CONFIG;
export const SETTING_URL = CONTENT_URL;
export const MODEL_BASE_URL = CONTENT_URL + MODEL_BASE;
export const TEXTURE_BASE_URL = CONTENT_URL + TEXTURE_BASE;